import { render } from "./ui-company-document.vue?vue&type=template&id=1d618e50&ts=true"
import script from "./ui-company-document.vue?vue&type=script&lang=ts"
export * from "./ui-company-document.vue?vue&type=script&lang=ts"

import "./ui-company-document.vue?vue&type=style&index=0&id=1d618e50&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__